import React, { useRef, useState } from 'react'
import { Link } from 'react-router-dom'
import { FaBars, FaTimes } from 'react-icons/fa'
import logo from '../Image/logo.webp'
import { IoIosArrowDown } from 'react-icons/io'
import Runing_bar from './Runing_bar'
import { MdKeyboardArrowRight } from 'react-icons/md'
import { TiArrowRight } from 'react-icons/ti'

function Main_Navbar() {
  const navRef = useRef()
  const [activeLink, setActiveLink] = useState('/')
  const [showProgramDropdown, setShowProgramDropdown] = useState(false)
  const [showCareersDropdown, setShowCareersDropdown] = useState(false)
  const [showSubDropdown, setShowSubDropdown] = useState({
    program1: false,
    program2: false,
    program3: false,
  })

  const showNavbar = () => {
    if (navRef.current) {
      navRef.current.classList.toggle('responsive_nav')
    }
  }

  const handleLinkClick = (path) => {
    setActiveLink(path)
    showNavbar()
  }

  return (
    <>
    <style>{`
        .top_bar_fix{
        position: fixed;
        top: 0;
        width:100%;
        z-index:3;
        }

        .nav-link-wrapper {
        display: inline-block;
        position: relative;
        }
        .nav-link {
        display: inline-block;
        padding-bottom: 5px;
        transition: border-bottom 0.3s ease;
        }
        .nav-link-wrapper.active .nav-link {
        border-bottom: 2px solid #565add;
        }
        header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        background-color:white;
        z-index:3;
        width:100%;
        }

        .Mobile_logo{width:50%;}
        .Tab_logo{width:50%;}
        .logo{width:70%;}

        header div,nav {
        display: flex;
        align-items: center;
        }

        nav li {
        list-style: none;
        text-decoration: none;
        font-family: 'Poppins', sans-serif;
        font-size:18px;
        user-select: none;
        }


        @media only screen and (max-width: 1024px) {
        header .nav-btn {
        visibility: visible;
        opacity: 1;
        }
        header nav {
        position: fixed;
        top: -104vh;
        left: 0;
        height: 100%;
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: 1.5rem;
        background-color:white;
        transition: 1s;
        }
        header .responsive_nav {
        transform: translateY(104vh);
        }
        nav .nav-close-btn {
        position: absolute;
        top: 2rem;
        right: 2rem;
        }
        nav li {
        font-size: 1.5rem;
        user-select: none;
        }
        }
        .nav-link-wrapper {
        position: relative;
        }
        .dropdown-menu{
        position: absolute;
        top: 100%;
        left:-100px;
        z-index: 1000;
        display: block;
        width:400px;
        float: left;
        list-style: none;
        background-color:white; 
        border-radius:5px;
        box-shadow: 0 .5rem 1rem rgba(0, 0, 0, .175);
        }
        .dropdown-item {
        position: relative;
        display: block;
        clear: both;
        text-align: center;
        font-size:16px;
        color:#2b1c50;
        font-family:"Poppins", sans-serif;
        user-select: none;
        }
        Link{
        text-decoration: none;
        }
        .dropdown-link{
        color:#2b1c50;
        text-decoration: none;
        user-select: none;
        }
        .dropdown-link:hover{
        color:#2b1c50;
        text-decoration: none;
        }
        .sub-dropdown-menu {
        position: absolute;
        top: -30px;
        left: 100%;
        z-index: 1000;
        display: block;
        float:right;
        padding: .5rem 0;
        margin: .125rem 0 0;
        width:340px;
        margin-left:1px;
        font-size: 1rem;
        background-color:white;
        color:#2b1c50;
        text-align: left;
        list-style: none;
        border-radius:5px;
        box-shadow: 0 .5rem 1rem rgba(0, 0, 0, .175);
        user-select: none;

        max-height: 450px;   
        overflow-y: auto;    
        overflow-x: hidden; 
        }
      `}</style>
    <div className="top_bar_fix">
      <div>
        <Runing_bar />
      </div>
      <header className="pb-2">
        <Link to="/">
          <img
            className="Mobile_logo px-2 d-sm-block d-md-none"
            src={logo}
            alt="InternsElite Logo"
            onContextMenu={(e) => e.preventDefault()}
          />
        </Link>
        <Link to="/">
          <img
            className="Tab_logo px-2 d-none d-md-block d-xl-none"
            src={logo}
            alt="InternsElite Logo"
            onContextMenu={(e) => e.preventDefault()}
          />
        </Link>
        <Link to="/">
          <img
            className="logo px-5  d-none d-xl-block d-md-none"
            src={logo}
            alt="InternsElite Logo"
            onContextMenu={(e) => e.preventDefault()}
          />
        </Link>
        <nav ref={navRef} className="pt-2">
          <li
            className={`px-1 nav-link-wrapper ${
              activeLink === '/' ? 'active' : ''
            }`}
          >
            <Link
              className="nav-link text-dark"
              to="/"
              onClick={() => handleLinkClick('/')}
            >
              Home
            </Link>
          </li>
          <li
            className={`px-1 nav-link-wrapper ${
              activeLink === '/About-Internselite' ? 'active' : ''
            }`}
          >
            <Link
              className="nav-link text-dark"
              to="/About-Internselite"
              onClick={() => handleLinkClick('/About-Internselite')}
            >
              About
            </Link>
          </li>
          <li
            className={`px-1 nav-link-wrapper d-md-block d-xl-none ${
              activeLink === '/Training-Programs' ? 'active' : ''
            }`}
          >
            <Link
              className="nav-link text-dark"
              to="/Training-Programs"
              onClick={() => handleLinkClick('/Training-Programs')}
            >
              Program
            </Link>
          </li>
          <li
            className={`px-1 nav-link-wrapper d-md-block d-xl-none ${
              activeLink === '/Careers' ? 'active' : ''
            }`}
          >
            <Link
              className="nav-link text-dark"
              to="/Careers"
              onClick={() => handleLinkClick('/Careers')}
            >
              Careers
            </Link>
          </li>
          <li
            className={`px-1 nav-link-wrapper d-none d-xl-block d-md-none ${
              activeLink === '/Training-Programs' ? 'active' : ''
            }`}
            onMouseEnter={() => setShowProgramDropdown(true)}
            onMouseLeave={() => setShowProgramDropdown(false)}
          >
            <Link
              className="nav-link text-dark"
              to=""
              onClick={() => handleLinkClick('')}
            >
              Program <IoIosArrowDown />
            </Link>
            {showProgramDropdown && (
              <ul className="dropdown-menu py-3">
                <li
                  className="dropdown-item"
                  onMouseEnter={() =>
                    setShowSubDropdown((prev) => ({ ...prev, program1: true }))
                  }
                  onMouseLeave={() =>
                    setShowSubDropdown((prev) => ({ ...prev, program1: false }))
                  }
                >
                  <Link className="dropdown-link">
                    <div className="row">
                      <div className="col-10">Traineeship Program</div>
                      <div className="col-2">
                        <MdKeyboardArrowRight />
                      </div>
                    </div>
                  </Link>
                  {showSubDropdown.program1 && (
                    <ul className="sub-dropdown-menu py-3  ">

                        <li>
                        <Link
                          className="dropdown-item"
                          to="/Android-App-Development"
                          onClick={() =>
                            handleLinkClick('/Android-App-Development')
                          }
                        >
                          <div className="row">
                            <div className="col-10">
                              Android App Development
                            </div>
                            <div className="col-2">
                              <TiArrowRight />
                            </div>
                          </div>
                        </Link>
                      </li>

                      <li>
                        <Link
                          className="dropdown-item"
                          to="/Artificial-Intelligence"
                          onClick={() =>
                            handleLinkClick('/Artificial-Intelligence')
                          }
                        >
                          <div className="row">
                            <div className="col-10">
                              Artificial Intelligence
                            </div>
                            <div className="col-2">
                              <TiArrowRight />
                            </div>
                          </div>
                        </Link>
                      </li>
                      <li>
                        <Link
                        className='dropdown-item'
                        to="/AR-VR"
                        onClick={()=>handleLinkClick("/AR-VR")}
                        >
                          <div className='row'>
                          <div className='col-10'>AR/VR</div>
                          <div className='col-2'>
                            <TiArrowRight/>
                          </div>
                          </div>
                        </Link>
                       </li>

                        <li className="my-1">
                        <Link
                          className="dropdown-item"
                          to="/Autocad"
                          onClick={() => handleLinkClick('/Autocad')}
                        >
                          <div className="row">
                            <div className="col-10">AutoCAD</div>
                            <div className="col-2">
                              <TiArrowRight />
                            </div>
                          </div>
                        </Link>
                      </li>

                      

                       <li>
                        <Link
                        className='dropdown-item'
                        to="/Bio-Informatics"
                        onClick={()=>handleLinkClick("/Bio-Informatics")}
                        >
                          <div className='row'>
                            <div className='col-10'>Bio Informatics</div>
                            <div className='col-2'>
                              <TiArrowRight/>
                            </div>
                          </div>
                        </Link>
                       </li>

                       <li>
                        <Link
                          className="dropdown-item"
                          to="/Business-Analytics"
                          onClick={() => handleLinkClick('/Business-Analytics')}
                        >
                          <div className="row">
                            <div className="col-10">Business Analytics</div>
                            <div className="col-2">
                              <TiArrowRight />
                            </div>
                          </div>
                        </Link>
                      </li>

                             <li className="my-1">
                        <Link
                          className="dropdown-item"
                          to="/Car-Design"
                          onClick={() => handleLinkClick('/Car-Design')}
                        >
                          <div className="row">
                            <div className="col-10">Car Design</div>
                            <div className="col-2">
                              <TiArrowRight />
                            </div>
                          </div>
                        </Link>
                      </li>

                       <li className="my-1">
                        <Link
                          className="dropdown-item"
                          to="/Cloud-Computing"
                          onClick={() => handleLinkClick('/Cloud-Computing')}
                        >
                          <div className="row">
                            <div className="col-10">Cloud Computing</div>
                            <div className="col-2">
                              <TiArrowRight />
                            </div>
                          </div>
                        </Link>
                      </li>

                       <li>
                        <Link
                          className="dropdown-item"
                          to="/Cyber-Security"
                          onClick={() => handleLinkClick('/Cyber-Security')}
                        >
                          <div className="row">
                            <div className="col-10">Cyber Security</div>
                            <div className="col-2">
                              <TiArrowRight />
                            </div>
                          </div>
                        </Link>
                      </li>

                        <li className="my-1">
                        <Link
                          className="dropdown-item"
                          to="/Data-Science"
                          onClick={() => handleLinkClick('/Data-Science')}
                        >
                          <div className="row">
                            <div className="col-10">Data Science</div>
                            <div className="col-2">
                              <TiArrowRight />
                            </div>
                          </div>
                        </Link>
                      </li>

                       <li>
                        <Link
                          className="dropdown-item"
                          to="/Digital-Marketing"
                          onClick={() => handleLinkClick('/Digital-Marketing')}
                        >
                          <div className="row">
                            <div className="col-10">Digital Marketing </div>
                            <div className="col-2">
                              <TiArrowRight />
                            </div>
                          </div>
                        </Link>
                      </li>

                      <li className="my-1">
                        <Link
                          className="dropdown-item"
                          to="/Embedded-Systems"
                          onClick={() => handleLinkClick('/Embedded-Systems')}
                        >
                          <div className="row">
                            <div className="col-10">Embedded Systems</div>
                            <div className="col-2">
                              <TiArrowRight />
                            </div>
                          </div>
                        </Link>
                      </li> 
                       <li className="my-1">
                        <Link
                          className="dropdown-item"
                          to="/Finance"
                          onClick={() => handleLinkClick('/Finance')}
                        >
                          <div className="row">
                            <div className="col-10">Finance</div>
                            <div className="col-2">
                              <TiArrowRight />
                            </div>
                          </div>
                        </Link>
                      </li>

                      <li>
                        <Link
                          className="dropdown-item"
                          to="/Generative-Artificial-Intelligence"
                          onClick={() =>
                            handleLinkClick('/Generative-Artificial-Intelligence')
                          }
                        >
                          <div className="row">
                            <div className="col-10">
                            Generative AI
                            </div>
                            <div className="col-2">
                              <TiArrowRight />
                            </div>
                          </div>
                        </Link>
                      </li>

                      <li className="my-1">
                        <Link
                          className="dropdown-item"
                          to="/Genetic-Engineering"
                          onClick={() => handleLinkClick('/Genetic-Engineering')}
                        >
                          <div className="row">
                            <div className="col-10">Genetic Engineering</div>
                            <div className="col-2">
                              <TiArrowRight />
                            </div>
                          </div>
                        </Link>
                       </li>

                        <li>
                        <Link
                        className='dropdown-item'
                        to='/Graphic-Design'
                        onClick={()=>handleLinkClick("/Graphic-Design")}
                        >
                          <div className='row'>
                            <div className='col-10'>Graphic Design</div>
                            <div className='col-2'>
                              <TiArrowRight/>
                              </div>                            
                          </div>                        
                        </Link>
                       </li>

                       <li className="my-1">
                        <Link
                          className="dropdown-item"
                          to="/Hybrid-Electric-Vehicle"
                          onClick={() => handleLinkClick('/Hybrid-Electric-Vehicle')}
                        >
                          <div className="row">
                            <div className="col-10">HEV (Hybrid Electric Vehicle)</div>
                            <div className="col-2">
                              <TiArrowRight />
                            </div>
                          </div>
                        </Link>
                       </li>

                       
                      <li>
                        <Link
                          className="dropdown-item"
                          to="/Human-Resources"
                          onClick={() => handleLinkClick('/Human-Resources')}
                        >
                          <div className="row">
                            <div className="col-10">Human Resource</div>
                            <div className="col-2">
                              <TiArrowRight />
                            </div>
                          </div>
                        </Link>
                      </li>
                       <li className="my-1">
                        <Link
                          className="dropdown-item"
                          to="/IC-Engine"
                          onClick={() => handleLinkClick('/IC-Engine')}
                        >
                          <div className="row">
                            <div className="col-10">IC Engine</div>
                            <div className="col-2">
                              <TiArrowRight />
                            </div>
                          </div>
                        </Link>
                       </li>
                       
                      <li>
                        <Link
                          className="dropdown-item"
                          to="/Internet-Of-Things"
                          onClick={() => handleLinkClick('/Internet-Of-Things')}
                        >
                          <div className="row">
                            <div className="col-10">Internet of Things (IoT)
</div>
                            <div className="col-2">
                              <TiArrowRight />
                            </div>
                          </div>
                        </Link>
                      </li>

                      {/* <li className="my-1">
                        <Link
                          className="dropdown-item"
                          to="/Machine-Learning"
                          onClick={() => handleLinkClick('/Machine-Learning')}
                        >
                          <div className="row">
                            <div className="col-10">Machine Learning </div>
                            <div className="col-2">
                              <TiArrowRight />
                            </div>
                          </div>
                        </Link>
                      </li> */}
                      <li className="my-1">
                        <Link
                          className="dropdown-item"
                          to="/Machine-Learning-With-Python"
                          onClick={() => handleLinkClick('/Machine-Learning-With-Python')}
                        >
                          <div className="row">
                            <div className="col-10">Machine Learning with Python</div>
                            <div className="col-2">
                              <TiArrowRight />
                            </div>
                          </div>
                        </Link>
                       </li>
                       <li className='my-1'>
                        <Link
                        className='dropdown-item'
                        to="/Nanoscience-Nanotechnology"
                        onClick={() => handleLinkClick("/Nanoscience-Nanotechnology")}
                        >
                          <div className='row'>
                            <div className='col-10'>Nanoscience & Nanotechnology</div>
                            <div className='col-2'>
                              <TiArrowRight/>
                            </div>
                          </div>
                        </Link>
                       </li>
                       <li className='my-1'>
                        <Link
                        className='dropdown-item'
                        to="/Psychology"
                        onClick={()=> handleLinkClick("/Psychology")}
                        >
                          <div className='row'>
                            <div className='col-10'>Psychology</div>
                            <div className='col-2'>
                              <TiArrowRight/>
                            </div>
                          </div>
                        </Link>
                       </li>
                           <li>
                        <Link
                        className='dropdown-item'
                        to='/Regulatory-Affairs'
                        onClick={()=>handleLinkClick("/Regulatory-Affairs")}
                        >
                          <div className='row'>
                            <div className='col-10'>Regulatory Affairs </div>
                            <div className='col-2'>
                              <TiArrowRight/>
                            </div>
                          </div>
                        </Link>
                       </li>
                         <li className="my-1">
                        <Link
                          className="dropdown-item"
                          to="/Robotics"
                          onClick={() => handleLinkClick('/Robotics')}
                        >
                          <div className="row">
                            <div className="col-10">Robotics</div>
                            <div className="col-2">
                              <TiArrowRight />
                            </div>
                          </div>
                        </Link>
                      </li>
                      
                       
                       <li className='my-1'>
                        <Link
                        className='dropdown-item'
                        to="/Stock-Market"
                        onClick={()=> handleLinkClick("/Stock-Market")}
                        >
                          <div className='row'>
                            <div className='col-10'>Stock Market</div>
                            <div className='col-2'>
                              <TiArrowRight/>
                            </div>
                          </div>
                        </Link>
                       </li>
                         <li className='my-1'>
                        <Link
                        className='dropdown-item'
                        to="/Supply-Chain-management"
                        onClick={()=> handleLinkClick("/Supply-Chain-Management")}
                        >
                          <div className='row'>
                          <div className='col-10'>Supply Chain Management</div>
                            <div className='col-2'>
                              <TiArrowRight/>
                            </div>
                          </div>
                        </Link>
                       </li>
                       

                       <li className='my-1'>
                        <Link 
                        className='dropdown-item'
                        to="/UI-UX-Design"
                        onClick={()=> handleLinkClick("/UI-UX-Design")}
                        >
                          <div className='row'>
                            <div className='col-10'>UI/UX Design</div>
                            <div className='col-2'>
                              <TiArrowRight/>
                            </div>
                          </div>
                        </Link>
                       </li>
                       
                       <li className="my-1">
                        <Link
                          className="dropdown-item"
                          to="/VlSI-Design"
                          onClick={() => handleLinkClick('/VlSI-Design')}
                        >
                          <div className="row">
                            <div className="col-10">VLSI Design</div>
                            <div className="col-2">
                              <TiArrowRight />
                            </div>
                          </div>
                        </Link>
                      </li>
                      <li>
                        <Link
                          className="dropdown-item"
                          to="/Web-Development"
                          onClick={() => handleLinkClick('/Web-Development')}
                        >
                          <div className="row">
                            <div className="col-10">Web Development</div>
                            <div className="col-2">
                              <TiArrowRight />
                            </div>
                          </div>
                        </Link>
                      </li>                      

                    </ul>
                  )}
                </li>
                <li
                  className="dropdown-item my-2"
                  onMouseEnter={() =>
                    setShowSubDropdown((prev) => ({ ...prev, program2: true }))
                  }
                  onMouseLeave={() =>
                    setShowSubDropdown((prev) => ({ ...prev, program2: false }))
                  }
                >
                  <Link className="dropdown-link">
                    <div className="row">
                      <div className="col-10">Advance Programs</div>
                      <div className="col-2">
                        <MdKeyboardArrowRight />
                      </div>
                    </div>
                  </Link>
                  {showSubDropdown.program2 && (
                    <ul className="sub-dropdown-menu py-2">

                      <li className="mt-2">
                        <Link
                          className="dropdown-item"
                          to="/C-CPP-DSA"
                          onClick={() => handleLinkClick('/C-CPP-DSA')}
                        >
                          <div className="row">
                            <div className="col-10">DSA with C, C++</div>
                            <div className="col-2">
                              <TiArrowRight />
                            </div>
                          </div>
                        </Link>
                      </li>
                       <li className="my-2">
                        <Link
                          className="dropdown-item"
                          to="/Full-Stack-Web-Development"
                          onClick={() =>
                            handleLinkClick('/Full-Stack-Web-Development')
                          }
                        >
                          <div className="row">
                            <div className="col-10">
                              Full Stack
                            </div>
                            <div className="col-2">
                              <TiArrowRight />
                            </div>
                          </div>
                        </Link>
                      </li>
                      <li>
                        <Link
                          className="dropdown-item"
                          to="/Java-Programming"
                          onClick={() => handleLinkClick('/Java-Programming')}
                        >
                          <div className="row">
                            <div className="col-10">Java Programming</div>
                            <div className="col-2">
                              <TiArrowRight />
                            </div>
                          </div>
                        </Link>
                      </li>
                      <li>
                        <Link
                          className="dropdown-item"
                          to="/Mern-Stack-Development"
                          onClick={() =>
                            handleLinkClick('/Mern-Stack-Development')
                          }
                        >
                          <div className="row">
                            <div className="col-10">Mern Stack Development</div>
                            <div className="col-2">
                              <TiArrowRight />
                            </div>
                          </div>
                        </Link>
                      </li>
                      <li className="my-2">
                        <Link
                          className="dropdown-item"
                          to="/Python-Programming"
                          onClick={() => handleLinkClick('/Python-Programming')}
                        >
                          <div className="row">
                            <div className="col-10">Python Programming</div>
                            <div className="col-2">
                              <TiArrowRight />
                            </div>
                          </div>
                        </Link>
                      </li>
                      {/* <li>
                        <Link
                          className="dropdown-item"
                          to="/Digital-Marketing-and-Marketing"
                          onClick={() =>
                            handleLinkClick('/Digital-Marketing-and-Marketing')
                          }
                        >
                          <div className="row">
                            <div className="col-10">
                              Digital Marketing & Marketing
                            </div>
                            <div className="col-2">
                              <TiArrowRight />
                            </div>
                          </div>
                        </Link>
                      </li> */}
                      
                    </ul>
                  )}
                </li>
                <li
                  className="dropdown-item my-2"
                  onMouseEnter={() =>
                    setShowSubDropdown((prev) => ({ ...prev, program3: true }))
                  }
                  onMouseLeave={() =>
                    setShowSubDropdown((prev) => ({ ...prev, program3: false }))
                  }
                >
                  <Link className="dropdown-link">
                    <div className="row">
                      <div className="col-10">Combo Program</div>
                      <div className="col-2">
                        <MdKeyboardArrowRight />
                      </div>
                    </div>
                  </Link>
                  {showSubDropdown.program3 && (
                    <ul className="sub-dropdown-menu py-2">
                      <li>
                        <Link
                          className="dropdown-item"
                          to="/Combo-Program"
                          onClick={() => handleLinkClick('/Combo-Program')}
                        >
                          <div className="row">
                            <div className="col-10">AI CyberGuard</div>
                            <div className="col-2">
                              <TiArrowRight />
                            </div>
                          </div>
                        </Link>
                      </li>
                      <li>
                        <Link
                          className="dropdown-item"
                          to="/Combo-Program"
                          onClick={() => handleLinkClick('/Combo-Program')}
                        >
                          <div className="row">
                            <div className="col-10">BizFinance Analytics</div>
                            <div className="col-2">
                              <TiArrowRight />
                            </div>
                          </div>
                        </Link>
                      </li>
                        <li className="">
                        <Link
                          className="dropdown-item"
                          to="/Combo-Program"
                          onClick={() => handleLinkClick('/Combo-Program')}
                        >
                          <div className="row">
                            <div className="col-10">CloudBrain</div>
                            <div className="col-2">
                              <TiArrowRight />
                            </div>
                          </div>
                        </Link>
                      </li>
                       <li className="mt-2">
                        <Link
                          className="dropdown-item"
                          to="/Combo-Program"
                          onClick={() => handleLinkClick('/Combo-Program')}
                        >
                          <div className="row">
                            <div className="col-10">DataPy</div>
                            <div className="col-2">
                              <TiArrowRight />
                            </div>
                          </div>
                        </Link>
                      </li>
                      <li className="my-2">
                        <Link
                          className="dropdown-item"
                          to="/Combo-Program"
                          onClick={() => handleLinkClick('/Combo-Program')}
                        >
                          <div className="row">
                            <div className="col-10">HR Digital</div>
                            <div className="col-2">
                              <TiArrowRight />
                            </div>
                          </div>
                        </Link>
                      </li>
                      <li className="my-2">
                        <Link
                          className="dropdown-item"
                          to="/Combo-Program"
                          onClick={() => handleLinkClick('/Combo-Program')}
                        >
                          <div className="row">
                            <div className="col-10">IoT Machines</div>
                            <div className="col-2">
                              <TiArrowRight />
                            </div>
                          </div>
                        </Link>
                      </li>
                      <li>
                        <Link
                          className="dropdown-item"
                          to="/Combo-Program"
                          onClick={() => handleLinkClick('/Combo-Program')}
                        >
                          <div className="row">
                            <div className="col-10">VLSI CAD</div>
                            <div className="col-2">
                              <TiArrowRight />
                            </div>
                          </div>
                        </Link>
                      </li>
                                           
                      <li className="my-2">
                        <Link
                          className="dropdown-item"
                          to="/Combo-Program"
                          onClick={() => handleLinkClick('/Combo-Program')}
                        >
                          <div className="row">
                            <div className="col-10">WebIntelligence</div>
                            <div className="col-2">
                              <TiArrowRight />
                            </div>
                          </div>
                        </Link>
                      </li>
                    
                     
                    </ul>
                  )}
                </li>
                {/* <li className="dropdown-item my-2">
                    <Link
                      to="/Up-Coming-Program"
                      onClick={() => handleLinkClick('/Up-Coming-Program')}
                      className="dropdown-link"
                    >
                      <div className="row">
                        <div className="col-10">Up Coming Program</div>
                        <div className="col-2">
                          <MdKeyboardArrowRight />
                        </div>
                      </div>
                    </Link>
                  </li>
                <li className="dropdown-item my-2">
                    <Link
                      to="/Coding-Skill-Program"
                      onClick={() => handleLinkClick('/Coding-Skill-Program')}
                      className="dropdown-link"
                    >
                      <div className="row">
                        <div className="col-10">Coding Skill Program</div>
                        <div className="col-2">
                          <MdKeyboardArrowRight />
                        </div>
                      </div>
                    </Link>
                </li> */}
              </ul>
            )}
          </li>
          <li
            className={`px-1 nav-link-wrapper d-none d-xl-block d-md-none ${
              activeLink === '/Careers' ? 'active' : ''
            }`}
            onMouseEnter={() => setShowCareersDropdown(true)}
            onMouseLeave={() => setShowCareersDropdown(false)}
          >
            <Link
              className="nav-link text-dark"
              to=""
              onClick={() => handleLinkClick('')}
            >
              Careers <IoIosArrowDown />
            </Link>
            {showCareersDropdown && (
              <ul className="dropdown-menu py-3">
                <li>
                  <Link
                    className="dropdown-item"
                    to="/Campus-Ambassador-Program"
                    onClick={() =>
                      handleLinkClick('/Campus-Ambassador-Program')
                    }
                  >
                    <div className="row">
                      <div className="col-12">
                        Become InternsElite’s Campus Ambassador
                      </div>
                    </div>
                  </Link>
                </li>
                <li className="my-2">
                  <Link
                    className="dropdown-item"
                    to="/Business-Development-Associate"
                    onClick={() =>
                      handleLinkClick('/Business-Development-Associate')
                    }
                  >
                    <div className="row">
                      <div className="col-12">Looking For A Job ?</div>
                    </div>
                  </Link>
                </li>
              </ul>
            )}
          </li>
          <li
            className={`px-1 nav-link-wrapper ${
              activeLink === '/Contact-Us' ? 'active' : ''
            }`}
          >
            <Link
              className="nav-link text-dark"
              to="/Contact-Us"
              onClick={() => handleLinkClick('/Contact-Us')}
            >
              Contact
            </Link>
          </li>
          <li className="nav-link-wrapper">
            <Link to="/Student-Register">
              <button
                className="shadow-sm mx-4 px-5 pt-2 pb-2 Navbar_button"
                onClick={() => handleLinkClick('/Student-Register')}
              >
                Register
              </button>
            </Link>
          </li>
          <button className="nav-btn nav-close-btn" onClick={showNavbar}>
            <FaTimes />
          </button>
        </nav>
        <button className="nav-btn" onClick={showNavbar}>
          <FaBars />
        </button>
      </header>
    </div>
    </>
  )
}

export default Main_Navbar
